var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeamChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3346 15L15.0013 16.6667L18.3346 13.3333M10.0013 12.5H6.66797C5.11483 12.5 4.33826 12.5 3.72569 12.7537C2.90893 13.092 2.26002 13.741 1.9217 14.5577C1.66797 15.1703 1.66797 15.9469 1.66797 17.5M14.168 2.7423C15.3896 3.23679 16.2513 4.43443 16.2513 5.83333C16.2513 7.23224 15.3896 8.42988 14.168 8.92437M11.2513 5.83333C11.2513 7.67428 9.75892 9.16667 7.91797 9.16667C6.07702 9.16667 4.58464 7.67428 4.58464 5.83333C4.58464 3.99238 6.07702 2.5 7.91797 2.5C9.75892 2.5 11.2513 3.99238 11.2513 5.83333Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamChat);
export default __webpack_public_path__ + "static/media/team-chat.d694c7ead6dcb1c5cec9b021df7dddb2.svg";
export { ForwardRef as ReactComponent };